import { Link } from 'react-router-dom';
import Icon from '../components/Icon.jsx';
import AuthShell, { AuthHead } from '../components/AuthShell.jsx';

/**
 * Signup starts by choosing who you are. Patients and nurses need genuinely
 * different things — a patient wants to book in under a minute, a nurse has
 * credentials to submit and a review to wait for — so they get separate forms
 * rather than one form with a toggle.
 */

const ROLES = [
  {
    to: '/register/patient',
    icon: 'heart',
    tone: '',
    title: 'I need care',
    sub: 'For yourself or a family member. Search verified nurses and book a visit in a few taps.',
    meta: { icon: 'clock', text: 'Takes about a minute' },
    cta: 'Sign up as a patient',
  },
  {
    to: '/register/nurse',
    icon: 'stethoscope',
    tone: 'icon-tile-info',
    title: 'I am a nurse',
    sub: 'Set your rates and availability, and receive booking requests from families near you.',
    meta: { icon: 'file-check', text: 'Needs your licence & certificates' },
    cta: 'Apply as a nurse',
  },
];

export default function Register() {
  return (
    <AuthShell maxWidth={820}>
      <AuthHead title="Create your account" subtitle="Tell us which one you are — we'll tailor the rest." />

      <div className="role-choice">
        {ROLES.map((r) => (
          <Link key={r.to} to={r.to} className="role-card">
            <span className={`icon-tile icon-tile-lg ${r.tone}`}>
              <Icon name={r.icon} />
            </span>
            <span className="role-title">{r.title}</span>
            <span className="role-sub">{r.sub}</span>
            <span className="role-meta">
              <Icon name={r.meta.icon} />
              {r.meta.text}
            </span>
            <span className="role-cta">
              {r.cta}
              <Icon name="arrow-right" />
            </span>
          </Link>
        ))}
      </div>

      <p className="auth-foot">
        Already registered? <Link to="/login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
